import * as z from "zod";
import { reconcileTenantAdminGrants } from "../rbac/tenantAdmins";
import { mutator } from "./mutator";

export const setTenantAdminsSchema = z.object({
  userIds: z.array(z.string()).min(1),
});

export const setTenantAdmins = mutator({
  schema: setTenantAdminsSchema,
  resolve: {
    users: { kind: "user", from: "userIds", many: true },
  },
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { users } }) => {
    await reconcileTenantAdminGrants(tx, users, ctx.tenantId);
  },
});
